import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import { JsonHttpClient } from '@ftdr/http-utils';
import { trimTrailingSlash, trimLeadingSlash } from './utils/url-utils.js';

/**
 * This is an abstract class that provides a simple base structure for
 */
var MicroService = /*#__PURE__*/function () {
  /**
   * This is a default constructor implementation that all concrete classes
   * inherit.
   *
   * It initializes the `httpClient` field to a simple `JsonHttpClient` instance,
   * if one is not passed as a constructor parameter.
   *
   * This functionality can/should be overridden in the derived class constrictor
   * as desired. Especially if a derived class is re-declaring the `httpClient`
   * field to change its type to a more specific HttpClient type. In such a case
   * the derived class would need to pass an HttpClient instance of this other
   * specific type. It can receive that instance as a constructor parameter of
   * its own, or can explicitly create and instance ans pass in. This logic is
   * down to the concrete class implementation detail.
   *
   * @param baseUrl The base URl to be used for all outgoing requests.
   * @param httpClient An HttpClient instance.
   */
  function MicroService(baseUrl, httpClient) {
    _classCallCheck(this, MicroService);
    this.httpClient = void 0;
    this.baseUrl = void 0;
    this.baseUrl = baseUrl;
    this.httpClient = httpClient !== null && httpClient !== void 0 ? httpClient : new JsonHttpClient();
  }
  _createClass(MicroService, [{
    key: "makeServiceUrl",
    value:
    /**
     * The name of the back-end micro service. This should be overridden in the
     * derived classes. This is used to form the API endpoint URL, so much be
     * set to an appropriate micro service name.
     */

    /**
     * An `HttpClient` instance from the `@ftdr/http-utils` package.
     *
     * Redeclare this field in derived classes to change its type to a more
     * specific `HttpClient` concrete class.
     */

    /**
     * The base URL to be used for all backend API calls.
     */

    /**
     * A helper method to form the full URL for making an API call.
     * It combines the `baseUrl` the `serviceName` and `endpointPath`.
     *
     * @param endpointPath The endpoint path for a specific API endpoint of the
     * service.
     */
    function makeServiceUrl(endpointPath) {
      var cleanBaseUrl = trimTrailingSlash(this.baseUrl);
      var serviceName = this.constructor.serviceName;
      var cleanEndpointPath = trimLeadingSlash(endpointPath);
      return "".concat(cleanBaseUrl, "/").concat(serviceName, "/").concat(cleanEndpointPath);
    }
  }]);
  return MicroService;
}();
MicroService.serviceName = void 0;

export { MicroService };
//# sourceMappingURL=micro-service.js.map
